<template>
    <ul class="dashboard-menu">

      <!--<router-link v-if="!authCheck" :to="{ name: 'register' }" tag="li" activeClass="m-menu__item&#45;&#45;active" class="m-menu__item" m-menu-submenu-toggle="hover">-->
      <!--<a class="m-menu__link">-->
      <!--<i class="fa fa-edit"></i>-->
      <!--<span class="m-menu__link-title">-->
      <!--<span class="m-menu__link-wrap">-->
      <!--<span class="m-menu__link-text">-->
      <!--Register-->
      <!--</span>-->
      <!--</span></span>-->
      <!--</a>-->
      <!--</router-link>-->

      <router-link v-if="!authCheck" :to="{ name: 'login' }" tag="li" activeClass="is-active">
        <a>
          <i class="fas fa-sign-in-alt"></i>Login
        </a>
      </router-link>


      <router-link v-if="authCheck" :to="{ name: 'printers.index' }" tag="li" activeClass="is-active">
        <a>
          <i class="fas fa-print"></i>Printers
        </a>
      </router-link>
      <router-link v-if="authCheck" :to="{ name: 'quotes.index' }" tag="li" activeClass="is-active">
        <a>
          <i class="fas fa-file"></i>Quotes
        </a>
      </router-link>

      <router-link :to="{ name: 'quotes.create' }" tag="li" activeClass="is-active">
        <a>
          <i class="fas fa-envelope"></i>Mail &amp; Franking
        </a>
      </router-link>

      <router-link :to="{ name: 'quotes.retrieve' }" tag="li" activeClass="is-active">
        <a>
          <i class="fas fa-redo"></i>Retrieve Quote
        </a>
      </router-link>

      <li v-if="authCheck" @click="logout">
        <a>
          <i class="fas fa-sign-out-alt"></i>Logout
        </a>
      </li>

    </ul>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex'

  export default {
    methods: {
      ...mapActions('auth', ['logout'])
    },
    computed: {
      ...mapGetters('auth', ['authCheck'])
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue